import { useField } from "formik";
import React from "react";
import Select, { components } from "react-select";

const CustomOption = ({ data, ...props }) => {
  // If value is null or empty, return a div
  if (!data || !data.value) {
    return (
      <components.Option {...props} data={data}>
        <div style={{ minHeight: "20px" }}>{props.children}</div>
      </components.Option>
    );
  }

  // Otherwise, return the default option
  return <components.Option {...props} data={data} />;
};
export function FormikSelect(props) {
  const [field, , helpers] = useField(props.name ? props.name : props.field);
  const { setValue, setTouched, setError } = helpers;

  const setFieldProps = (selectedOptions) => {
    if (props.isMulti) {
      const values = selectedOptions.map((option) => option.value);
      if (values.includes("")) {
        setValue("");
      } else {
        setValue(selectedOptions.map((option) => option.value));
      }
    } else {
      setValue(selectedOptions?.value);
    }

    if (props.onChange) {
      props.onChange(selectedOptions);
    }

    setTimeout(() => {
      setTouched(true);
      setError(undefined);
    }, 0);
  };

  return (
    <Select
      value={
        props.isMulti
          ? props.options
            .filter((option) => option.value)
            .filter((option) => field.value.includes(option.value))
          : props?.options?.find((option) => option.value === field.value) || ""
      }
      isDisabled={props.isDisabled}
      menuPortalTarget={document.body}
      menuIsOpen={props.menuIsOpen}
      isMulti={props.isMulti}
      inputProps={{
        "data-testid": `select-${props.name}`,
        id: props.id || props.name,
      }}
      data-id={`select-${props.name}`}
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
          ...(props.width && { width: props.width }),
        }),
      }}
      className={`reactSelect-wrapper ${!props.edit ? "reactSelect-readOnly" : "mt-1"
        }`}
      classNamePrefix="reactSelect"
      options={props.options}
      isClearable={props.isClearable}
      onChange={(selectedOptions) => setFieldProps(selectedOptions)}
      components={{ Option: CustomOption }}
    />
  );
}
